import { render } from "./PageLayout.vue?vue&type=template&id=598ada58&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=598ada58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-598ada58"

export default script